import { Badge as AntBadge, BadgeProps } from "antd";
import styled from "styled-components";

export const Badge: typeof AntBadge = styled(AntBadge)<BadgeProps>``;
